module.exports = __webpack_public_path__ + "static/media/Home Hero.5fa87afc.jpg";